module.exports = __webpack_public_path__ + "img/acaki16.705359a0.jpg";